import NavigationControls from "./NavigationControls";
import PropTypes from "prop-types";
import React from "react";
import compare from "../../../lib/compare.js";

export default class ExperimentalMetalToneQuestion extends React.PureComponent {

  static propTypes = {
    "answers": PropTypes.array.isRequired,
    "header": PropTypes.element.isRequired,
    "multiSelect": PropTypes.bool.isRequired,
    "nextRoute": PropTypes.string,
    "onAnswer": PropTypes.func.isRequired,
    "prevRoute": PropTypes.string,
    "skip": PropTypes.object,
    "surveyFields": PropTypes.object.isRequired
  };

  static defaultProps = {
    "nextRoute": null,
    "prevRoute": null,
    "skip": null
  };

  constructor (props) {
    super(props);

    this.metalTones = [
      "Gold",
      "Silver"
    ];

    this.defaultAnswers = {
      "preferredMetalTone": null,
      "wearsGold": true,
      "wearsSilver": true
    };

    // This is for UI only
    const selections = {
      "Gold": null,
      "Rose Gold": null,
      "Silver": null
    };
    const {surveyFields} = props;

    if (!compare.objectShallow(this.defaultAnswers, surveyFields)) {
      [
        "Gold",
        "Silver"
      ].forEach(metalTone => (
        selections[metalTone] = surveyFields[`wears${metalTone}`] ? 2 : 0
      ));
      selections.preferredMetalTone = surveyFields.preferredMetalTone;
    }

    this.state = {selections};
  }

  renderButton (metalTone, label, activeIndex, currentIndex) { // eslint-disable-line max-params
    const {onAnswer} = this.props;
    const activeLike = activeIndex === 1 || activeIndex === 2;
    const answer = {};
    const currentLike = currentIndex === 1 || currentIndex === 2;
    const heapClass = `metal-tone-response-${metalTone.toLowerCase().replace(" ", "-")}-${currentIndex}`;
    const isSelected = activeIndex === currentIndex;

    if (currentLike && currentLike !== activeLike) {
      answer[`wears${metalTone}`] = true;
      if (metalTone !== "Rose Gold") {
        answer.preferredMetalTone = "gold";
      }
    } else if (currentIndex === 0 && currentIndex !== activeIndex) {
      answer[`wears${metalTone}`] = false;
    }

    return (
      <button
        className={`btn btn-tertiary ${heapClass} ${isSelected ? "active" : ""}`}
        key={label}
        onClick={() => this.setState(prevState => ( // eslint-disable-line react/jsx-no-bind
          {
            "selections": Object.assign(
              {...prevState.selections},
              {[metalTone]: currentIndex}
            )
          }
        ),
        // Don't update API on "Rose Gold" response
        () => (metalTone !== "Rose Gold") && onAnswer(answer, isSelected))
        }
        type="button"
      >
        {label}
      </button>
    );
  }

  render () {
    const {header, nextRoute, onAnswer, prevRoute, skip} = this.props;
    const {selections} = this.state;

    return (
      <div className="StyleSurveyQuestion">
        {header}
        <div className="StyleSurveyAnswers metal-tone mb16">
          {
            [
              "Gold",
              "Silver",
              "Rose Gold"
            ].map(metalTone => (
              <div key={metalTone}>
                <h5>
                  {metalTone}
                </h5>
                <div className="btn-group">
                  {
                    [
                      "Never",
                      "Sometimes",
                      "Often"
                    ].map((label, index) => this.renderButton(metalTone, label, selections[metalTone], index))
                  }
                </div>
              </div>
            ))
          }
        </div>
        <NavigationControls
          nextRoute={nextRoute}
          onAnswer={onAnswer}
          prevRoute={prevRoute}
          skip={skip}
        />
      </div>
    );
  }
}
